import styled from "styled-components";

export const OverusedMessage = styled.span`
    color: #d82829;
`;
